(() => {
  if (!customElements.get("product-reccommendations")) {
    class ProductRecommendations extends HTMLElement {
      async connectedCallback() {
        this.productID = this.getAttribute("data-product-id");
        this.sectionID = this.getAttribute("data-section-id");
        this.productCount = 10;
        try {
          const response = await fetch(
            `${
              window.Shopify.routes.root
            }recommendations/products?product_id=${this.productID}&limit=${this.productCount}&section_id=${this.sectionID}`,
          );
          const responseText = await response.text();
          if (!response.ok) {
            throw new Error("");
          }
          const html = new DOMParser().parseFromString(responseText, "text/html");

          const productSlider = html.querySelector("product-slider");
          if (productSlider) {
            // Check if the product slider has products inside it
            const products = productSlider.querySelectorAll(".swiper-slide");
            if (products && products.length > 0) {
              this.append(productSlider);
            } else {
              // Hide the entire component if there are no products
              this.style.display = "none";
            }
          } else {
            // Hide the entire component if product slider doesn't exist
            this.style.display = "none";
          }
        } catch (error) {
          console.log(error);
          // Hide the component on error
          this.style.display = "none";
        }
      }
    }

    customElements.define("product-reccommendations", ProductRecommendations);
  }
})();
